import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getRoutes } from '@/app/lib/navigation/get-routes';

const routes = getRoutes({
  selectProperties: ['label', 'to', 'show', 'public', 'layout', 'noHeader'],
  flat: true,
});

export const useCurrentRoute = (path?: string) => {
  const location = useLocation();

  return useMemo(
    () => routes.find((x) => x.to === (path || location.pathname)),
    [location.pathname, path],
  );
};